module.exports = __webpack_public_path__ + "img/02.a6981410.png";